import { botFilterOptions } from '../../constants/app.constants';
import { botActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  CheckBackBtn: false,
  pageNo: 1,
  bots: {
    data: {},
    message: '',
  },
  botNames: {
    data: {},
    message: '',
  },
  createBot: {
    data: {},
    message: '',
  },
  botDetails: {
    data: {},
    message: '',
  },
  error: '',
  filter: {
    [botFilterOptions.User]: [],
    [botFilterOptions.Status]: [],
  },
  botUpdateDetails: {
    data: null,
    message: '',
  },
  botDeleteData: {
    data: null,
    message: '',
  },
  botDownloadData: {
    data: null,
    message: '',
  },
};

const BotReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SET_BOT_UPDATE_DATA:
      return {
        ...state,
        botUpdateDetails: {
          data: action.payload,
        },
      };
    case ACTION.REMOVE_BOT_UPDATE_DATA:
      return {
        ...state,
        botUpdateDetails: {
          data: null,
          message: '',
        },
        error: '',
      };
    case ACTION.BOT_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.BOT_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.BOT_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.BOT_START_FETCH:
      return {
        ...state,
        loading: true,
      };

    case ACTION.BOT_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.BOT_REMOVE_ERROR:
      return {
        ...state,
        error: '',
      };

    case ACTION.FETCH_BOTS_SUCCESS:
      return {
        ...state,
        loading: false,
        bots: {
          ...state.bots,
          data: action.payload,
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_BOTS_FAILURE:
      return {
        ...state,
        loading: false,
        bots: {
          ...state.bots,
          data: null,
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_BOTS:
      return {
        ...state,
        loading: false,
        bots: {
          ...state.bots,
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_BOTS_POPUP:
      return {
        ...state,
        loading: false,
        bots: {
          ...state.bots,
          message: '',
        },
        createBot: {
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.CREATE_BOT_SUCCESS:
      return {
        ...state,
        loading: false,
        createBot: {
          ...state.createBot,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.CREATE_BOT_FAILURE:
      return {
        ...state,
        loading: false,
        createBot: {
          data: {},
          message: '',
        },
        error: action.payload,
      };

    case ACTION.FETCH_BOT_DETAILS_SUCCESS:
      let idtoupdate = action.payload.id;
      let updatedBot =
        state.bots.data && state.bots.data.rows
          ? state.bots.data.rows.map((item) => {
              if (item.id == idtoupdate) return action.payload;
              return item;
            })
          : [];
      return {
        ...state,
        loading: false,
        bots: {
          ...state.bots,
          data: {
            ...state.bots.data,
            rows: [...updatedBot],
          },
        },
        botDetails: {
          ...state.botDetails,
          data: action.payload,
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_BOT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        botDetails: {
          ...state.botDetails,
          data: {},
          message: action.payload,
        },
        error: '',
      };

    case ACTION.REMOVE_BOT_DETAILS:
      return {
        ...state,
        loading: false,
        botDetails: {
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_BOT_DETAILS_POPUP:
      return {
        ...state,
        loading: false,
        botDetails: {
          ...state.botDetails,
          message: '',
        },
        error: '',
      };

    case ACTION.DELETE_BOT_SUCCESS:
      const { data, message } = action.payload;
      return {
        ...state,
        loading: false,
        botDeleteData: {
          message,
          data,
        },
        error: '',
      };
    case ACTION.REMOVE_BOT_DELETE_DATA:
      return {
        ...state,
        loading: false,
        botDeleteData: {
          message: '',
          data: null,
        },
        error: '',
      };

    case ACTION.DELETE_BOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.UPDATE_BOT_SUCCESS:
      return {
        ...state,
        loading: false,
        botUpdateDetails: {
          ...state.botUpdateDetails,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.UPDATE_BOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.FETCH_BOT_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        botNames: {
          ...state.botNames,
          data: action.payload.data.payload,
          message: '',
        },
        error: action.payload,
      };
    case ACTION.FETCH_BOT_FILE_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTION.FETCH_BOT_FILE_DOWNLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_BOT_FILE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        botDownloadData: {
          ...state.botDownloadData,
          data: action.payload,
        },
      };
    case ACTION.GET_BOT_BACKBTN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: true,
      };
    case ACTION.GET_BOT_BACKBTN_FAILURE:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: false,
      };
    case ACTION.UPDATE_BOT_PAGE:
      return {
        ...state,
        pageNo: action.payload,
      };
    default:
      return state;
  }
};

export default BotReducer;
